<div class="edit-dialog">
  <div class="table-header d-flex flex-row justify-content-between align-items-center h-20">
    <h2 class="m-4">
      Édition d'utilisateur
    </h2>
  </div>

  <mat-dialog-content>
    <form *ngIf="editForm" class="mt-2 w-100 bordered corners" name="editForm" novalidate [formGroup]="editForm"
      noValidate>
      <!-- User Info Section -->
      <div class="row w-100">
        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>ID</mat-label>
            <input required matInput type="text" formControlName="id" readonly [disabled]="true" class="text-muted" />
          </mat-form-field>
        </div>

        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Identifiant de connexion</mat-label>
            <input required matInput type="text" formControlName="login" readonly [disabled]="true"
              class="text-muted" />
          </mat-form-field>
        </div>
      </div>

      <!-- Names -->
      <div class="row w-100">
        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Prénom</mat-label>
            <input matInput type="text" formControlName="firstName" />
          </mat-form-field>
        </div>

        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Nom</mat-label>
            <input matInput type="text" formControlName="lastName" />
          </mat-form-field>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="row w-100">
        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Email</mat-label>
            <input required matInput type="email" formControlName="email" />
          </mat-form-field>
        </div>

        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Langue</mat-label>
            <input matInput type="text" formControlName="language" />
          </mat-form-field>
        </div>
      </div>

      <!-- Additional Info (Read-only) -->
      <div class="row w-100 mt-3">
        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Créé le</mat-label>
            <input matInput type="text" [value]="(user.createdAt | date: 'dd/MM/yyyy HH:mm')" readonly [disabled]="true"
              class="text-muted" />
          </mat-form-field>
        </div>

        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Statut</mat-label>
            <input matInput type="text" [value]="(user.activated ? 'Activé' : 'Désactivé')" readonly [disabled]="true"
              class="text-muted" />
          </mat-form-field>
        </div>
      </div>

      <!-- Groups & Permissions Section -->
      <div class="row w-100 mt-4">
        <h3 class="col-sm-12">Groupes et Agences</h3>
      </div>

      <!-- Agencies Section (Read-only) -->
      <div class="row w-100 mt-4">
        <div class="col-sm-12">
          <h5>Agences de l'utilisateur</h5>
          <div *ngIf="isLoadingGroups" class="text-center">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
          <div *ngIf="!isLoadingGroups && userAgencies.length === 0" class="alert alert-info">
            Cet utilisateur n'est member d'aucune agence.
          </div>
          <div *ngIf="!isLoadingGroups && userAgencies.length > 0" class="user-groups-list">
            <div *ngFor="let agency of userAgencies" class="group-item mb-3">
              <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1">
                  <h6 class="mb-2">
                    <strong>{{ agency.groupName }}</strong>
                    <span class="badge badge-info">Agence</span>
                  </h6>
                  <div class="permissions-chips">
                    <mat-chip *ngFor="let perm of agency.permissions" [disabled]="true">
                      {{ perm.name }}
                    </mat-chip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Current User Groups -->
      <div class="row w-100 mt-4">
        <div class="col-sm-12">
          <h5>Groupes actuels de l'utilisateur</h5>
          <div *ngIf="isLoadingGroups" class="text-center">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
          <div *ngIf="!isLoadingGroups && userNonAgencyGroups.length === 0" class="alert alert-info">
            Cet utilisateur n'est member d'aucun groupe.
          </div>
          <div *ngIf="!isLoadingGroups && userNonAgencyGroups.length > 0" class="user-groups-list">
            <div *ngFor="let group of userNonAgencyGroups" class="group-item mb-3">
              <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1">
                  <h6 class="mb-2">
                    <strong>{{ group.groupName }}</strong>
                    <span class="badge" [ngClass]="group.isProducer ? 'badge-warning' : 'badge-info'">
                      {{ group.isProducer ? 'Producteur' : 'Client' }}
                    </span>
                  </h6>
                  <div class="permissions-chips">
                    <mat-chip *ngFor="let perm of group.permissions" [disabled]="true">
                      {{ perm.name }}
                    </mat-chip>
                  </div>
                </div>
                <button mat-icon-button color="warn" (click)="removeGroupFromUser(group.groupId)"
                  [disabled]="isRemovingGroup" matTooltip="Retirer l'utilisateur du groupe">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Add Group Section -->
      <div class="row w-100 mt-4 p-3 bg-light rounded">
        <h5 class="col-sm-12 mb-3">Ajouter l'utilisateur à un groupe</h5>

        <!-- Group Selection -->
        <div class="col-sm-6">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sélectionner un groupe</mat-label>
            <mat-select [value]="selectedGroupId" (selectionChange)="onGroupSelected($event.value)">
              <mat-select-trigger *ngIf="selectedGroupId">{{ getGroupName(selectedGroupId) }}</mat-select-trigger>
              <mat-option *ngFor="let group of availableGroups" [value]="group.id">
                {{ group.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Permissions Selection -->
        <div class="col-sm-6">
          <div *ngIf="selectedGroupId" class="permissions-selection">
            <h6>Permissiones à assigner:</h6>
            <mat-checkbox *ngFor="let perm of allPermissions" [checked]="isPermissionSelected(perm.id)"
              (change)="togglePermission(perm.id)" class="permission-checkbox">
              {{ perm.name }}
            </mat-checkbox>
          </div>
          <div *ngIf="!selectedGroupId" class="text-muted">
            Sélectionnez d'abord un groupe
          </div>
        </div>

        <!-- Add Button -->
        <div class="col-sm-12 mt-3">
          <button mat-raised-button color="primary" (click)="addGroupToUser()"
            [disabled]="!canAddGroup() || isAddingGroup" type="button">
            <mat-icon *ngIf="!isAddingGroup">add</mat-icon>
            <mat-spinner *ngIf="isAddingGroup" diameter="20" class="me-2"></mat-spinner>
            {{ isAddingGroup ? 'Ajout en cours...' : 'Ajouter le groupe' }}
          </button>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="row mt-3 justify-content-between w-50">
        <div class="col-sm-2">
          <button mat-raised-button class="admin" [disabled]="editForm.invalid || isSaving || !editForm.dirty"
            (click)="onSubmitForm()" type="button">
            <mat-icon>save</mat-icon>
            Sauvegarder
          </button>
        </div>
        <div class="col-sm-2">
          <button mat-raised-button class="delete" *ngIf="!this.forceDelete" (click)="askDelete()" type="button">
            <mat-icon>delete</mat-icon>
            Supprimer
          </button>
          <button mat-raised-button class="force-delete" *ngIf="this.forceDelete" (click)="confirmDeletion()"
            type="button">
            <mat-icon>delete</mat-icon>
            Confirmer
          </button>
        </div>
      </div>
      <div class="row mt-2 justify-content-center" style="color:red; font-weight: bold;" *ngIf="this.forceDelete">
        ATTENTION : Vous avez demandé la suppression de l'utilisateur. Cliquer de nouveau pour confirmer.
      </div>
    </form>
  </mat-dialog-content>
</div>